module.exports = __webpack_public_path__ + "polling-target.9b33b74a46493338c89f5913794de36e.hashedasset.svg";